import { useSelector } from 'react-redux';
import {
    getAssignments,
    getAssignmentsStatus,
    getEmptyAssignments,
    getEmptyAssignmentsStatus,
    getProductsAsSourceSet,
    getProductsMode,
    getSelectedProduct,
    getSelectedProductId,
    isProductsPaneVisible,
} from './index';

export const useIsProductsPaneVisible = () =>
    useSelector(isProductsPaneVisible);

export const useProductsMode = () => useSelector(getProductsMode);
export const useProductAssignments = () => useSelector(getAssignments);
export const useProductAssignmentsStatus = () =>
    useSelector(getAssignmentsStatus);

export const useProductEmptyAssignments = () =>
    useSelector(getEmptyAssignments);
export const useProductEmptyAssignmentsStatus = () =>
    useSelector(getEmptyAssignmentsStatus);

export const useSourceSet = () => useSelector(getProductsAsSourceSet);
export const useSelectedProductId = () => useSelector(getSelectedProductId);
export const useSelectedProduct = () => useSelector(getSelectedProduct);
